import { useRef } from 'react';
import { useStorefront } from '@kega/sps-core';
import { useDispatch } from 'react-redux';
import { updateCart } from '@kega/sps-core/src/reducers/cart/actions';

/**
 * Custom hook to handle cart restoration from orders with proper payment session management
 * This ensures that when a payment is cancelled/refused and the cart is restored from an order,
 * the hasOngoingPaymentSession flag is properly cleared to prevent cart auto-clearing
 */
const useCartRestoration = () => {
    const { api: { occadyen, cart } } = useStorefront();
    const dispatch = useDispatch();
    const restorationInProgress = useRef(false);

    const restoreCartFromOrder = async (orderCode, userId) => {
        if (!orderCode || !userId || restorationInProgress.current) {
            return false;
        }

        try {
            restorationInProgress.current = true;

            await occadyen.cartFromOrder({ orderCode, userId });

            const restoredCart = await cart.getDetails();

            if (restoredCart) {
                const cleanedCart = {
                    ...restoredCart,
                    hasOngoingPaymentSession: false
                };

                dispatch(updateCart(cleanedCart));

                return true;
            }

            return false;

        } catch (error) {
            return false;
        } finally {
            restorationInProgress.current = false;
        }
    };

    return {
        restoreCartFromOrder,
        isRestorationInProgress: () => restorationInProgress.current
    };
};

export default useCartRestoration;
